function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M91 300v90h330v-90zm0 0",
  fill: "#ff9f00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M256 300h165v90H256zm0 0",
  fill: "#ff7816"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M422.5 169.2l-24.3 47.398H113.8l-24.3-47.399C125.2 119.7 187.3 90 256 90s130.8 29.7 166.5 79.2zm0 0",
  fill: "#ff4b00"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M422.5 169.2l-24.3 47.398H256V90c68.7 0 130.8 29.7 166.5 79.2zm0 0",
  fill: "#cc1e0d"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M477.102 139.2L421 330H91L34.898 139.2 72.7 124.8c17.102 32.7 49.801 51.9 76.5 55.2h15.602c34.5-5.398 60.297-58.2 70.8-108.602h40.801c10.5 50.403 36.301 103.204 70.797 108.602h15.602c26.699-3.3 59.398-22.5 76.5-55.2zm0 0",
  fill: "#fdbf00"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M477.102 139.2L421 330H256V71.398h20.398C286.902 121.801 312.7 174.602 347.2 180h15.602c26.699-3.3 59.398-22.5 76.5-55.2zM46 150c-24.813 0-46-20.188-46-45s21.188-45 46-45 45 20.188 45 45-20.188 45-45 45zm0 0",
  fill: "#ff9f00"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M466 150c-24.813 0-45-20.188-45-45s20.188-45 45-45 46 20.188 46 45-21.188 45-46 45zm0 0",
  fill: "#ff7816"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M256 0c-24.902 0-45 20.098-45 45 0 24.898 20.098 45 45 45s45-20.102 45-45c0-24.902-20.098-45-45-45zm0 0",
  fill: "#ff9f00"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M256 173.7L204.7 225l51.3 51.3 51.3-51.3zm0 0",
  fill: "#ff4b00"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M346 233.785l21.21 21.211L346 276.207l-21.21-21.21zm0 0",
  fill: "#cc1e0d"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M166 233.785l21.21 21.211L166 276.207l-21.21-21.21zm0 0",
  fill: "#ff4b00"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M256 90V0c24.902 0 45 20.098 45 45 0 24.898-20.098 45-45 45zm0 0",
  fill: "#ff7816"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M307.3 225L256 276.3V173.7zm0 0",
  fill: "#cc1e0d"
});

function SvgLeaderboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -61 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.4285dc1e.svg";
export { ForwardRef as ReactComponent };